
// stores/userStore.js
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,          // 用户信息对象
        token: null,         // 认证令牌
        isAuthenticated: false // 认证状态
    }),
    actions: {
        // 设置用户信息（登录成功后调用）
        setUser(userData, authToken) {
            this.user = userData
            this.token = authToken
            this.isAuthenticated = true
        },

        // 清除用户信息（登出时调用）
        clearUser() {
            this.user = null
            this.token = null
            this.isAuthenticated = false
        },

        // 从本地存储初始化用户状态（应用启动时调用）
        initialize() {
            const portalUser = localStorage.getItem('tenantAdmin:user') || localStorage.getItem('platformAdmin:user')
            const portalToken = localStorage.getItem('tenantAdmin:token') || localStorage.getItem('platformAdmin:token')

            if (portalUser && portalToken) {
                this.user = JSON.parse(portalUser)
                this.token = portalToken
                this.isAuthenticated = true
            }
        },
    },
    getters: {
        // 获取用户全名
        fullName: (state) => {
            return state.user ? `${state.user.firstName} ${state.user.lastName}` : ''
        },

        // 检查用户角色
        isAdmin: (state) => {
            return state.user?.role === 'admin'
        },

        // 用户信息
        userInfo: (state) => {
            return state.user
        }
    },
    persist: {
        enabled: true,   // 表示启用数据持久化
        strategies: [
            // isCollapsed字段用 localstorage存储
            {
                storage: localStorage,
                key: "userInfo",
            },

        ]
    }
})

